import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://znbtbwkhblxaavwgwjpk.supabase.co';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpuYnRid2toYmx4YWF2d2d3anBrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgxNzk3ODAsImV4cCI6MjA5Mzc1NTc4MH0.CxN6Hiff26oHjo7jO_uRCufqYOef1IWMtEmVa0viw9A';

export const supabase = createClient(supabaseUrl, supabaseKey);
